import { components, type NoticeProps } from "react-select";
import { _ } from "i18n";
import type { ProgramGameSelectOption } from "./types";

/**
 * Factory for an AsyncSelect `NoOptionsMessage` that offers to create a club
 * when the search returns nothing. Falls back to the default message when the
 * user cannot create clubs or the query is empty.
 */
export function makeCreateClubNoOptionsMessage(
	canCreateClub: boolean,
	onRequestCreateClub: (name: string) => void,
) {
	return function CreateClubNoOptionsMessage(props: NoticeProps<ProgramGameSelectOption, false>) {
		const inputValue = props.selectProps.inputValue?.trim() ?? "";
		if (!canCreateClub || inputValue === "") {
			return <components.NoOptionsMessage {...props} />;
		}
		return (
			<div
				className="discoverGamesProgramModal-createClub"
				role="button"
				tabIndex={0}
				// onMouseDown + preventDefault: react-select blurs (closing the menu)
				// before a click handler would fire.
				onMouseDown={(event) => {
					event.preventDefault();
					event.stopPropagation();
					onRequestCreateClub(inputValue);
				}}
			>
				{`${_("filter.add_club")}: "${inputValue}"`}
			</div>
		);
	};
}
